import React from "react";
import styled from "styled-components";

// Styled Components for styling
const ValuePropsSection = styled.section`
  padding: 60px 20px;
  background-color: #f8f8f8;
  text-align: center;
`;

const ValuePropsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); /* Responsive columns */
  justify-content: center; /* Center the grid content */
  align-items: flex-start;
  gap: 40px; /* Adjust gap for better spacing */
  max-width: 1200px; /* Set a max-width for the grid */
  margin: 0 auto; /* Center the grid within the section */
`;

const ValueProp = styled.div`
  background: rgb(131, 236, 229);
  padding: 45px;
  border-radius: 200px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
  position: relative;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0px 10px 20px rgba(8, 8, 8, 0.2);
  }
`;

const ValuePropTitle = styled.h3`
  font-size: 19px;
  font-weight: 750;
  margin-bottom: 15px;
  color:rgb(29, 29, 29);
`;

const ValuePropDescription = styled.p`
  font-size: 18px;
  color:rgb(119, 116, 116);
`;

const ValueProps = () => (
  <ValuePropsSection id="keyvalue">
    <h1 style={{ fontSize: "38px", marginBottom: "40px", color: "#333333" }}>
      Key Value Propositions
    </h1>
    <ValuePropsWrapper>
      <ValueProp>
        <ValuePropTitle>AI-Optimized Micro-Hubs</ValuePropTitle>
        <ValuePropDescription>
          Leverage the power of AI to ensure the{" "}
          <strong>right inventory is in the right micro-hub</strong>, perfectly
          positioned to meet customer demand quickly and efficiently.
        </ValuePropDescription>
      </ValueProp>

      <ValueProp>
        <ValuePropTitle>Hyperlocal Precision</ValuePropTitle>
        <ValuePropDescription>
          Serve your customers faster with AI-driven{" "}
          <strong>hyperlocal inventory placement</strong>, reducing delivery
          times and increasing satisfaction with customers.
        </ValuePropDescription>
      </ValueProp>

      <ValueProp>
        <ValuePropTitle>Predictive Inventory Management</ValuePropTitle>
        <ValuePropDescription>
          AI-powered forecasting predicts{" "}
          <strong>what to stock and how much to keep</strong>, minimizing
          overstocking and stockouts while improving efficiency.
        </ValuePropDescription>
      </ValueProp>

      <ValueProp>
        <ValuePropTitle>Faster Deliveries, Happier Customers</ValuePropTitle>
        <ValuePropDescription>
          Strategically optimized micro-hubs enable{" "}
          <strong>lightning-fast deliveries</strong>, keeping your customers
          delighted with speed and reliability in par with Quick commerce.
        </ValuePropDescription>
      </ValueProp>
    </ValuePropsWrapper>
  </ValuePropsSection>
);

export default ValueProps;
